import {FC, ReactNode, useState} from 'react'
import styles from './BaseModal.module.css'
import Swal from 'sweetalert2'
import {i18n} from '../../../translate/i18n'

type Props = {
  onCloseAction: () => void
  title: string
  children?: ReactNode
  width?: string
  disableClose?: boolean
  editPageProduct?: boolean
  showAlert?: boolean
}

const BaseModal: FC<Props> = ({
  onCloseAction,
  title,
  children,
  width = '30rem',
  disableClose = false, // Isso significa "fechar sem confirmar"
  editPageProduct = false,
  showAlert = true,
}) => {
  const [isClosing, setIsClosing] = useState(false)

  const doClose = () => {
    if (isClosing) return
    setIsClosing(true)
    setTimeout(onCloseAction, 300)
  }

  const handleClose = async () => {
    // 1) Fechar imediatamente (sem alerta)
    if (disableClose) {
      doClose()
      return
    }

    // 2) Com alerta de confirmação
    if (showAlert) {
      const result = await Swal.fire({
        title: String(i18n.t('base_modal.attention_title')),
        text: String(i18n.t('base_modal.unsaved_changes_text')),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: String(i18n.t('base_modal.confirm_button')),
        cancelButtonText: String(i18n.t('base_modal.cancel_button')),
      })
      if (result.isConfirmed) doClose()
      return
    }

    // 3) Fechar sem alerta (showAlert = false)
    doClose()
  }

  return (
    <>
      <div
        onClick={handleClose}
        className={`${styles.background} ${isClosing ? styles.fadeOut : ''}`}
      />
      <div className={`${styles.modalCustom} ${isClosing ? styles.slideOut : ''}`} style={{width}}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3 className={styles.modalTitle}>{title}</h3>
            <button type='button' className={styles.closeButton} onClick={handleClose}>
              <i className={`fas fa-times ${styles.closeButtonIcon}`} />
            </button>
          </div>
          <div className={!editPageProduct ? styles.modalBody : styles.modalBodyEdit}>
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export {BaseModal}
